import { usePageCapabilities } from "../../Shared/usePageCapabilities";

export function useAdminDiscourseCapabilities(authenticatedUser) {
  const capabilities = {
    showAdminDiscourseNavigation: false,
    showPublishedDiscourseNavigation: authenticatedUser?.inDiscourseExperiment,
    showYourDiscourseNavigation: authenticatedUser?.inDiscourseExperiment,
    showNewDiscourseNavigation: authenticatedUser?.inDiscourseExperiment,
  };

  usePageCapabilities(capabilities, []);
}